<template>
    <div>
        <div class="columns is-multiline pt-6">
            <router-link
                v-for="project in projects"
                :key="project._id"
                :to="{
                    name: 'project',
                    params: { projectId: project._id },
                }"
                tag="div"
                class="column is-4"
            >
                <project-card :content="project" />
            </router-link>
        </div>
    </div>
</template>

<script>
import ProjectCard from '@/components/ProjectCard';
export default {
    components: {
        ProjectCard,
    },
    props: {
        projects: {
            type: Array,
            default() {
                return [];
            },
        },
    },
};
</script>

<style></style>
